import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as _actionsJourney from '../../../actions/journey1';
import { Button, EButtonType, BoxInput, IBoxInputAlignment, IBoxInputTypes } from '@repo/apg-ui';
import './Step6.scss';
import * as actions from '../../../actions/index';
import { RootState } from '../../../reducers';
import { ReactComponent as IconInnovation } from '../../../assets/icons/e_i_innovation.svg';
import { ReactComponent as WerbemittelAnalog } from '../../../assets/icons/19_werbemittel_analog.svg';
import { ReactComponent as WebemittelDigital } from '../../../assets/icons/20_webemittel_digital.svg';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney: typeof _actionsJourney;
  intl: any;
  locales: any;
  possibleBookingDates: any;
  urlHistory: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
}

const Step6 = (props: Props) => {
  const advertisingTypeRadioOptions = [
    {
      title: props.intl.formatMessage({
        id: 'ec.navigation.analogeWerbemittel',
        defaultMessage: 'Analoge Werbeträger',
      }),
      text: props.intl.formatMessage({
        id: 'ec.journey02.step06.analogTooltip',
        defaultMessage: 'wie Plakate, Hängekartons in Bus und Tram usw.',
      }),
      icon: <WerbemittelAnalog />,
      value: '0',
      gtmEvent: 'pb_j1_analog_advert_panels_click',
    },
    {
      title: props.intl.formatMessage({
        id: 'ec.navigation.digitaleWerbemittel',
        defaultMessage: 'Digitale Werbeträger',
      }),
      text: props.intl.formatMessage({
        id: 'ec.journey02.step06.digitalTooltip',
        defaultMessage: 'wie Werbespots auf Bildschirmen (Screens) in Bus und Tram, in Bahnhöfen usw.',
      }),
      icon: <WebemittelDigital />,
      value: '1',
      gtmEvent: 'pb_j1_digital_advert_panels_click',
    },
  ];

  const [digital, setDigital] = React.useState(['0']);

  const navigate = useNavigate();

  useEffect(() => {
    const option = props.userDataEC.digital;
    let _digital;
    if (option === 0) {
      _digital = ['0'];
    } else if (option === 1) {
      _digital = ['1'];
    } else {
      _digital = ['0', '1'];
    }

    setDigital(_digital);
    if (props.userDataEC.duration === null || props.userDataEC.startDate === null) {
      navigate({ pathname: '/journey1/5' });
    }

    if (
      props.userDataEC.possibleFormats?.data.digital != 1 &&
      props.urlHistory[props.urlHistory.length - 2]?.includes('/journey1/7')
    ) {
      navigate({ pathname: '/journey1/5' });
    }
  }, []);

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
  //     if (prevState.digital !== this.state.digital) {
  //         this.saveDigital();
  //     }
  // }

  const saveDigital = () => {
    props.actionsJourney.updateDigital(!digital.length || digital.length > 1 ? 2 : parseInt(digital[0] || '0'));
  };

  const next = () => {
    saveDigital();

    navigate('/journey1/7');
  };

  return (
    <div className='step6'>
      <div>
        <div className='header'>
          <h4 className='title-journey'>
            <FormattedMessage
              id='ec.journey01.step06.header'
              defaultMessage='Welche Werbeträger möchten Sie einsetzen'
            />
          </h4>
        </div>

        <div className='d-flex mt-48'>
          <BoxInput
            id='advertising-input'
            selected={digital}
            type={IBoxInputTypes.Checkbox}
            alignment={IBoxInputAlignment.FullWidth}
            options={advertisingTypeRadioOptions}
            onChange={(_digital: string | any[]) => {
              setDigital([..._digital]);
              props.actionsJourney.updateDigital(_digital.length > 1 ? 2 : parseInt(_digital[0] || '0'));

              // this.setState(
              //     {
              //         digital: [..._digital],
              //     },
              //     () => {
              //         this.props.actionsJourney.updateDigital(
              //             this.state.digital.length > 1 ? 2 : parseInt(this.state.digital[0] || '0')
              //         );
              //     }
              // );
            }}
          />
        </div>

        <div className='informationText'>
          <p className='fw-bold title-journey'>
            <FormattedMessage
              id='ec.journey01.step06.title'
              defaultMessage='Möchten Sie gewisse Werbeträger ausschliessen?'
            />
          </p>
          <div className='d-flex'>
            <IconInnovation />
            <div className='w-100'>
              <p className='text-left align-self-center me-48 fw-normal w-100 sub-title'>
                <FormattedMessage
                  id='ec.journey01.step06.budgetTextPart1'
                  defaultMessage='Bitte beachten Sie: Je mehr Formate Sie wählen, desto höher fallen die Kosten für die Kreation und Produktion Ihres Werbesujets aus.
                                        Wenn Sie sich unsicher fühlen, wählen Sie am besten beide Optionen (analog und digital). Sie können Ihre Auswahl später noch anpassen.'
                />
              </p>
            </div>
          </div>
        </div>

        <div className='d-flex twoButtons mt-5'>
          <Button onClick={() => navigate({ pathname: '/journey1/5' })} buttonType={EButtonType.InvertedPillMedium}>
            <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
          </Button>
          <Button
            isDisabled={digital.length === 0}
            onClick={() => next()}
            buttonType={EButtonType.PillMedium}
            className='ms-4'
          >
            <FormattedMessage id='ec.components.buttons.next' defaultMessage='Weiter' />
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step6)));
